import {
    AccessorsMutatorsDecorator,
    Model
} from "../../helpers";

import moment from "moment";
import momentTimezone from "moment-timezone";
export class ReservationCommunication extends Model {


    static get messageTypes() {

        return {
            'EMAIL': 1,
            'SMS': 2,
        };
    }

    static get availableStatuses() {

        return [{
                key: '1',
                label: 'SENT'
            },
            {
                key: '2',
                label: 'DELIVERED'
            },
            {
                key: '3',
                label: 'FAILED'
            }
        ];
    }

    get properDateFormat() {

        return {
            'dd/MM/yyyy': 'DD/MM/YYYY',
            'MM/dd/yyyy': 'MM/DD/YYYY'
        }
    }

    /**
     * @todo add proper date formating or move this to controller
     */

    setCreatedAt(value) {

        const dateFormat = this.properDateFormat[this.constructor.generalSettings.date_format];

        const dateTimeFormat = dateFormat + (this.constructor.generalSettings.time_format == '12'? ' hh:mm A': ' HH:mm');

        this.date_sent = momentTimezone.tz(value, 'UTC').tz(this.constructor.generalSettings.time_zone).format(dateTimeFormat);

        return value;
    }

   setType(value) {

        this.type_label = this.constructor.$translate.instant(value == '1'? 'EMAIL': 'SMS');

        return value;
    }

    setStatus(value) {

       const status = ReservationCommunication.availableStatuses.find(ast => ast.key == value);

       this.status_label = this.constructor.$translate.instant(status.label);

       return value;
       
    }

}

AccessorsMutatorsDecorator('id', 'guest_name', 'guest_contact_data', 'subject', 'preview', 'type', 
'status', 'guest_id', 'reservation_id', 'guest', 'reservation', 'updated_at', 'created_at')(ReservationCommunication);


// WEBPACK FOOTER //
// ./src/pms-api/models/reservation-communication.model.js